import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.gallery',
        body: 'body',
        mainSlides: '.gallery__main-slides',
        mainSlide: '.gallery__main-slide',
        mainSlideVisual: '.gallery__main-slide-visual',
        previewSlides: '.gallery__preview-slides',
        previewSlide: '.gallery__preview-slide',
        next: '.gallery__next',
        prev: '.gallery__prev',
        openBtn: '.gallery__open-btn',
        caption: '.gallery__caption',
        videoPlayButton: '.vjs-big-play-button',
        video: '.video-js',
        videoControls: '.video__controls',
        closeBtn: '.gallery__close-btn',
        currentMainSlide: '.gallery__main-slide.slick-current',
        fullscreenVideo: '.video__fullscreen',
        fullscreenPlayButton: '.video__play-pause',
        volume: '.video__volume',
        seekslider: '.video__seekslider',
    },
    classNames: {
        noScroll: 'no-scroll',
        lightboxVisible: 'gallery__lightbox--visible',
        fullscreenVideo: 'gallery--fullscreen',
        videoOverlay: 'video--overlay',
        volumeMute: 'video__volume--mute',
        volume25: 'video__volume--25',
        volume50: 'video__volume--50',
        volume75: 'video__volume--75',
        volume100: 'video__volume--100',
        currentTime: '.video__currentTime',
        durationTime: '.video__durationTime',
    },
    playIcon: '<span class="video__play-pause-icon icon-TickCirclePlay3"></span><span class="tooltip">Play</span>',
    pauseIcon: '<span class="video__play-pause-icon icon-TickCirclePause3"></span><span class="tooltip">Pause</span>',
    dataAttributes: {
        slickIndex: 'slick-index',
    },
    mainSliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1.15,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.MD,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
        // asNavFor: '.gallery__preview-slides',

    },
    previewSliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,

    },
};

// eslint-disable-next-line import/prefer-default-export
export class Gallery {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._imagesHtml = [];
        this._captionsHtml = [];
    }

    init() {
        this._elements = this._getDomElements();
        this._elements.$mainSlides.slick(config.mainSliderConfig);
        this._elements.$previewSlides.slick(config.previewSliderConfig);
        this._addEventListeners();

        this._elements.$mainSlide.each((i, el) => {
            this._imagesHtml.push($(el).find(config.selectors.mainSlideVisual).html());
            this._captionsHtml.push($(el).find(config.selectors.caption).html());
        });
    }

    static initLater($rootElement) {
        const imagesHtml = [];
        const captionsHtml = [];
      
        const $elements = {
            $body: $(config.selectors.body),
            $root: $rootElement.find(config.selectors.root),
            $mainSlides: $rootElement.find(config.selectors.mainSlides),
            $mainSlide: $rootElement.find(config.selectors.mainSlide),
            $previewSlides: $rootElement.find(config.selectors.previewSlides),
            $previewSlide: $rootElement.find(config.selectors.previewSlide),
            $next: $rootElement.find(config.selectors.next),
            $prev: $rootElement.find(config.selectors.prev),
            $openBtn: $rootElement.find(config.selectors.openBtn),
            $closeBtn: $rootElement.find(config.selectors.closeBtn),
            $playButton: $rootElement.find(config.selectors.videoPlayButton),
            $videoControls: $rootElement.find(config.selectors.videoControls),
            $caption: $rootElement.find(config.selectors.caption),
            $fullscreenVideo: $rootElement.find(config.selectors.fullscreenVideo),
            $fullscreenPlayButton: $rootElement.find(config.selectors.fullscreenPlayButton),
            $volume: $rootElement.find(config.selectors.volume),
            $seekslider: $rootElement.find(config.selectors.seekslider),
            $video: $rootElement.find(config.selectors.video),
        };

        $($elements.$previewSlide[0]).addClass('gallery__preview-slide--active');

        
        $elements.$mainSlide.each((index, el) => {
            const video = $(el).find('.video-js')[0];

            if (video) {
                // eslint-disable-next-line no-undef
              
                bc(video);
            }

         
        });

       
        //refactoring clear names to variable names
        $('.gallery__main-slides').on('afterChange', () =>{
            let childrenisvideo = $rootElement.find('.slick-current').find('.gallery__main-slide-visual').children()[0]
            if($(childrenisvideo).hasClass('video')){
                $rootElement.find('.gallery__main-slides-wrapper').addClass('gallery__main-slides-wrapper--video')
            }else {
                $rootElement.find('.gallery__main-slides-wrapper').removeClass('gallery__main-slides-wrapper--video')
            }
        });

        $elements.$mainSlides.slick(config.mainSliderConfig);
        // $elements.$previewSlides.slick(config.previewSliderConfig);

        $elements.$next.on('click', () => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];
          
            if (videoSettings) {
                videoSettings.player.pause();
                $elements.$fullscreenPlayButton.html(config.playIcon);
            }
           
            $elements.$mainSlides.slick('slickNext');
            $elements.$previewSlides.slick('slickNext');
            // _setCurrentPreviewSlide();
        });

        $elements.$prev.on('click', () => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];

            if (videoSettings) {
                videoSettings.player.pause();
                $elements.$fullscreenPlayButton.html(config.playIcon);
            }

            $elements.$mainSlides.slick('slickPrev');
            $elements.$previewSlides.slick('slickPrev');
            // _setCurrentPreviewSlide();
        });

        function _goFullscreen() {
             //refactoring clear names to variable names
            if($('.overlay').hasClass('overlay--full-screen')){
                if(document.documentElement.requestFullscreen) {
                    $rootElement.find('.gallery__main-slide.slick-slide.slick-current')[0].requestFullscreen()
                }else if(document.documentElement.webkitEnterFullscreen) {
                    $rootElement.find('.gallery__main-slide.slick-slide.slick-current')[0].webkitEnterFullscreen()
                }
                screen.orientation.lock("landscape-primary")
            }else {
                if(document.documentElement.requestFullscreen) {
                    $('.gallery')[0].requestFullscreen()
                }else if(document.documentElement.webkitEnterFullscreen) {
                    $('.gallery')[0].webkitEnterFullscreen()
                }
                screen.orientation.lock("landscape-primary")
            }
        }; 

        function _exitFullscreen() {
            //refactoring clear names to variable names
            if($('.gallery__main-slide.slick-slide.slick-current').hasClass('gallery__main-slide--fullscreen')){
                $rootElement.find('.gallery__main-slide.slick-slide.slick-current').removeClass('gallery__main-slide--fullscreen')
            }else {
                if(document.fullscreenElement) {
                    document.exitFullscreen();
                
                }else if( document.webkitFullscreenElement) {
                    document.webkitExitFullScreen()
                }
                if(screen.width <= 900 && !$('body').hasClass('safari')) {
                    $rootElement.closest('.overlay').removeClass('overlay--full-screen');
                    screen.orientation.unlock()
                }
            }
            
           
        }
        //refactoring clear names to variable names
        function _changeFullscreenState(isFullscreen=Boolean) {
            if(isFullscreen && screen.width >= 900) {
                $rootElement.closest('.overlay').removeClass('overlay--full-screen');
                $rootElement.find('.gallery__open-btn').removeClass('icon-arrowShrink').addClass('icon-StateDark13');
            }else {
                $elements.$videoControls.removeClass('video__controls--hidden');
                $rootElement.closest('.overlay').addClass('overlay--full-screen');
                if(screen.width >= 900) {
                $rootElement.find('.gallery__open-btn').removeClass('icon-StateDark13').addClass('icon-arrowShrink');
                }
            }
        }

        $elements.$closeBtn.on('click', () => {
            // this._elements.$mainSlides.slick('unslick');
            const index = $rootElement.find('.slick-current').data('slick-index');
            $elements.$videoControls.addClass('video__controls--hidden');

            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
                $elements.$fullscreenPlayButton.html(config.playIcon);
            }

            $elements.$mainSlides.slick('unslick');
            $elements.$mainSlides.slick(config.mainSliderConfig);
            $elements.$mainSlides.slick('slickGoTo', index);

            $elements.$previewSlides.slick('slickGoTo', index);
            $elements.$previewSlides.slick('unslick');
            $elements.$previewSlides.slick(config.previewSliderConfig);

            if(screen.width <= 900 ) {
                _exitFullscreen();
            }else {
                $rootElement.find('.gallery__open-btn').removeClass('icon-arrowShrink').addClass('icon-StateDark13');
                $rootElement.closest('.overlay').removeClass('overlay--full-screen');
            }

        });   

        

        $elements.$openBtn.on('click', function()  {
            // this._elements.$mainSlides.slick('unslick');
            const index = $rootElement.find('.slick-current').data('slick-index');
            if(screen.width <= 900 && !$('body').hasClass('safari')) {
                _goFullscreen();
            }
          
            

            if( $rootElement.closest('.overlay').hasClass('overlay--full-screen')) {
                 _changeFullscreenState(true)
            }else {
                _changeFullscreenState(false)
            }

            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
                $elements.$fullscreenPlayButton.html(config.playIcon);
            }

            $elements.$mainSlides.slick('unslick');
            $elements.$mainSlides.slick(config.mainSliderConfig);
            $elements.$mainSlides.slick('slickGoTo', index);

        });

        $elements.$mainSlides.on('afterChange', () => {
            // _setCurrentPreviewSlide();
        });

        $elements.$previewSlide.each((i, el) => {
            el.addEventListener('click', () => {
                $elements.$mainSlides.slick('slickGoTo', i);
                $elements.$previewSlide.removeClass('gallery__preview-slide--active');
                $(el).addClass('gallery__preview-slide--active');
            })
        })

        // eslint-disable-next-line func-names
        // $elements.$previewSlide.on('click', function () {
        //     const $el = $(this);
        //     const index = $el.data('slick-index');

        //     $elements.$mainSlides.slick('slickGoTo', index);

        //     $elements.$previewSlide.removeClass('slick-current');
        //     $(this).addClass('slick-current');
        // });

        $elements.$volume.on('click', (e) => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];
            const volumeValue = e.currentTarget.value / 100;
            if (videoSettings.player.volume() === 0) {
                videoSettings.player.volume(0.25);
                $rootElement.find('.slick-current').find('.video__volume--mute').hide();
                $rootElement.find('.slick-current').find('.video__volume--25').show();
            } else if (videoSettings.player.volume() === 0.25) {
                videoSettings.player.volume(0.5);
                $rootElement.find('.slick-current').find('.video__volume--25').hide();
                $rootElement.find('.slick-current').find('.video__volume--50').show();
            } else if (videoSettings.player.volume() === 0.50) {
                videoSettings.player.volume(0.75);
                $rootElement.find('.slick-current').find('.video__volume--50').hide();
                $rootElement.find('.slick-current').find('.video__volume--75').show();
            } else if (videoSettings.player.volume() === 0.75) {
                videoSettings.player.volume(1);
                $rootElement.find('.slick-current').find('.video__volume--75').hide();
                $rootElement.find('.slick-current').find('.video__volume--100').show();
            } else if (volumeValue === 1) {
                videoSettings.player.volume(0);
                $rootElement.find('.slick-current').find('.video__volume--100').hide();
                $rootElement.find('.slick-current').find('.video__volume--mute').show();
            }
        });

        $elements.$fullscreenVideo.on('click', (e) => {
            // ('fullscreen click');
            if ($rootElement.hasClass(config.classNames.fullscreenVideo)) {
                $rootElement.removeClass(config.classNames.fullscreenVideo);
            } else {
                $rootElement.addClass(config.classNames.fullscreenVideo);
                // this._elements.$backdrop.addClass('');
            }
            $rootElement.find('.slick-current').find('.video').removeClass('video--fullscreen');
        });

        $elements.$fullscreenPlayButton.on('click', (e) => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];

            if (videoSettings.player.hasStarted()) {
                if (!videoSettings.player.paused()) {
                    videoSettings.player.pause();
                    $elements.$fullscreenPlayButton.html(config.playIcon);
                } else {
                    videoSettings.player.play();
                    _seeksliderTimeUpdate(videoSettings);
                    $elements.$fullscreenPlayButton.html(config.pauseIcon);
                }
            } else {
                videoSettings.player.play();
                _seeksliderTimeUpdate(videoSettings);
                $elements.$fullscreenPlayButton.html(config.pauseIcon);
            }
        });

        $elements.$playButton.on('click', (e) => {
            // eslint-disable-next-line no-console
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];

            if (videoSettings.player.hasStarted()) {
                if (!videoSettings.player.paused()) {
                    videoSettings.player.pause();
                    $elements.$fullscreenPlayButton.html(config.playIcon);
                } else {
                    videoSettings.player.play();
                    _seeksliderTimeUpdate(videoSettings);
                    $elements.$fullscreenPlayButton.html(config.pauseIcon);
                }
            } else {
                videoSettings.player.play();
                _seeksliderTimeUpdate(videoSettings);
                $elements.$fullscreenPlayButton.html(config.pauseIcon);
            }
        });

        $elements.$seekslider.on('change', (e) => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];

            const seekTo = videoSettings.player.duration() * ($rootElement.find('.slick-current').find('.video__seekslider')[0].value / 100);
            videoSettings.player.currentTime(seekTo);
        });

        $elements.$video.on('click', (e) => {
            const videoSettings = $rootElement.find('.slick-current').find('.video-js')[0];
            const videoPaused = $rootElement.find('.slick-current').find('.video-js').hasClass('vjs-paused');

            if (videoPaused) {
                videoSettings.player.play();
                _seeksliderTimeUpdate(videoSettings);
                $elements.$fullscreenPlayButton.html(config.pauseIcon);
            } else {
                videoSettings.player.pause();
                $elements.$fullscreenPlayButton.html(config.playIcon);
            }

        });

        $elements.$mainSlide.each((i, el) => {
            imagesHtml.push($(el).find(config.selectors.mainSlideVisual).html());
            captionsHtml.push($(el).find(config.selectors.caption).html());
        });
       
        function _setCurrentPreviewSlide() {
            // eslint-disable-next-line no-unused-vars
            const _this = this;
            const currentslide = $rootElement.find(config.selectors.currentMainSlide);
            const currentindex = currentslide.data(config.dataAttributes.slickIndex);
            $elements.$previewSlide.removeClass('slick-current');

            // eslint-disable-next-line max-len
            for (let index = 0; index < $rootElement.find(config.selectors.previewSlide).length; index++) {
                const element = $rootElement.find(config.selectors.previewSlide)[index];
                if ($(element).data(config.dataAttributes.slickIndex) === currentindex) {
                    $(element).addClass('slick-current');
                }
            }
        }

        function _seeksliderTimeUpdate(videoSettings) {
            videoSettings.player.on('timeupdate', () => {
                if (videoSettings.player.ended()) {
                    videoSettings.player.pause();
                    return;
                }
                const newTime = videoSettings.player.currentTime() * (100 / videoSettings.player.duration());
                $rootElement.find('.slick-current').find('.video__seekslider')[0].value = newTime;
                let curmins = Math.floor(videoSettings.player.currentTime() / 60);
                let cursecs = Math.floor(videoSettings.player.currentTime() - curmins * 60);
                let durmins = Math.floor(videoSettings.player.duration() / 60);
                let dursecs = Math.floor(videoSettings.player.duration() - durmins * 60);
                if (cursecs < 10) { cursecs = `0${cursecs}`; }
                if (dursecs < 10) { dursecs = `0${dursecs}`; }
                if (curmins < 10) { curmins = `0${curmins}`; }
                if (durmins < 10) { durmins = `0${durmins}`; }

                $rootElement.find('.slick-current').find('.video__currentTime').html(`${curmins}:${cursecs}`);
                $rootElement.find('.slick-current').find('.video__durationTime').html(`${durmins}:${dursecs}`);
            });
        }
    }

  



    _getDomElements() {
        return {
            $body: $(config.selectors.body),
            $mainSlides: this._$rootElement.find(config.selectors.mainSlides),
            $mainSlide: this._$rootElement.find(config.selectors.mainSlide),
            $previewSlides: this._$rootElement.find(config.selectors.previewSlides),
            $previewSlide: this._$rootElement.find(config.selectors.previewSlide),
            $next: this._$rootElement.find(config.selectors.next),
            $prev: this._$rootElement.find(config.selectors.prev),
            $openBtn: this._$rootElement.find(config.selectors.openBtn),
            $closeBtn: this._$rootElement.find(config.selectors.closeBtn),
            $videoControls: this._$rootElement.find(config.selectors.videoControls),
            $caption: this._$rootElement.find(config.selectors.caption),
            $playButton: this._$rootElement.find(config.selectors.videoPlayButton),
            $video: this._$rootElement.find(config.selectors.video),
            $currentMainSlide: this._$rootElement.find(config.selectors.currentMainSlide),
            $fullscreenVideo: this._$rootElement.find(config.selectors.fullscreenVideo),

        };
    }

    _setCurrentPreviewSlide() {
        const _this = this;
        const currentslide = _this._$rootElement.find(config.selectors.currentMainSlide);
        const currentindex = currentslide.data(config.dataAttributes.slickIndex);
        _this._elements.$previewSlide.removeClass('slick-current');

        for (let index = 0; index < $(config.selectors.previewSlide).length; index++) {
            const element = $(config.selectors.previewSlide)[index];
            if ($(element).data(config.dataAttributes.slickIndex) === currentindex) {
                $(element).addClass('slick-current');
            }
        }
    }

    _addEventListeners() {
        const _this = this;

        this._elements.$next.on('click', () => {
            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
            }
            this._elements.$mainSlides.slick('slickNext');
            this._elements.$previewSlides.slick('slickNext');
            this._setCurrentPreviewSlide();
        });

        this._elements.$prev.on('click', () => {
            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
            }
            this._elements.$mainSlides.slick('slickPrev');
            this._elements.$previewSlides.slick('slickPrev');
            this._setCurrentPreviewSlide();
        });

        this._elements.$openBtn.on('click', () => {
            // this._elements.$mainSlides.slick('unslick');
            const index = this._$rootElement.find('.slick-current').data('slick-index');
            this._elements.$videoControls.removeClass('video__controls--hidden');

            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
            }

            this._elements.$mainSlides.slick('unslick');
            this._elements.$mainSlides.slick(config.mainSliderConfig);
            this._elements.$mainSlides.slick('slickGoTo', index);
        });

        this._elements.$closeBtn.on('click', () => {
            // this._elements.$mainSlides.slick('unslick');
            const index = this._$rootElement.find('.slick-current').data('slick-index');
            this._elements.$videoControls.addClass('video__controls--hidden');

            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];
            if (videoSettings) {
                videoSettings.player.pause();
            }

            this._elements.$mainSlides.slick('unslick');
            this._elements.$mainSlides.slick(config.mainSliderConfig);
            this._elements.$mainSlides.slick('slickGoTo', index);

            this._elements.$previewSlides.slick('slickGoTo', index);
        });

        this._elements.$fullscreenVideo.on('click', (e) => {
            // eslint-disable-next-line no-console
            if (this._$rootElement.hasClass(config.classNames.fullscreenVideo)) {
                this._$rootElement.removeClass(config.classNames.fullscreenVideo);
            } else {
                this._$rootElement.addClass(config.classNames.fullscreenVideo);
                // this._elements.$backdrop.addClass('');
            }
            this._$rootElement.find('.slick-current').find('.video').removeClass('video--fullscreen');
        });

        this._elements.$playButton.on('click', (e) => {
            const videoSettings = this._$rootElement.find('.slick-current').find('.video-js')[0];

            if (videoSettings.player.hasStarted()) {
                if (!videoSettings.player.paused()) {
                    videoSettings.player.pause();
                } else {
                    videoSettings.player.play();
                }
            } else {
                videoSettings.player.play();
            }
        });

        this._elements.$mainSlides.on('afterChange', () => {
            _this._setCurrentPreviewSlide();
        });

        // eslint-disable-next-line func-names
        this._elements.$previewSlide.on('click', function () {
            const $el = $(this);
            const index = $el.data('slick-index');

            _this._elements.$mainSlides.slick('slickGoTo', index);

            _this._elements.$previewSlide.removeClass('slick-current');
            $(this).addClass('slick-current');
        });
    }
}

moduleRegistry.registerModule('Gallery', Gallery);
moduleRegistry.autoApplyModule('Gallery', config.selectors.root);

window.KSGallery = Gallery;
